import React from "react";
import AccessHolderList from "../../components/AccessHolders/AccessHolderList";
import { Switch, useHistory, useLocation } from "react-router-dom";
import { useStyles } from "./styles";
import ProtectedRoute from "../../components/ProtectedRoute";
import useCurrentFacility from "../../hooks/useCurrentFacility";
import CreateEditAccessHolder from "../../components/AccessHolders/CreateEditAccessHolder";
import AccessGroupProvider from "../../providers/AccessGroupsProvider";

const  AccessHolderPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { facilityID } = useCurrentFacility();
  const accessHolderID = location?.state?.accessHolderID;

  const handleAdd = () => {
    history.push("/contracts/accessholders/details");
  };

  const handleAccessHolderChange = (id) => {
    history.push({pathname: "/contracts/accessholders/details",
      state: { accessHolderID: id },
    });
  };

  const handleDelete = () => {
    history.push("/contracts/accessholders");
  };

  return (
    <div className={classes.root}>
      <Switch>
        <AccessGroupProvider>
        <ProtectedRoute
          exact
          path="/contracts/accessholders"
          permissions={["accessholders.view"]}
        >
          <AccessHolderList
            onAddClick={handleAdd}
            onSelect={handleAccessHolderChange}
          />
        </ProtectedRoute>
        <ProtectedRoute
          exact
          path="/contracts/accessholders/details"
          permissions={["accessholders.view"]}
        >
          <CreateEditAccessHolder
            key ={accessHolderID??"new"}
            accessHolderID={accessHolderID}
            facilityID={facilityID}
            onDelete={handleDelete}
          />
        </ProtectedRoute>
        </AccessGroupProvider>
      </Switch>
    </div>
  );
};

export default AccessHolderPage;
